import PropTypes from "prop-types";
import React from "react";

const FirstMaiVisit = ({showDesc, title}) => {
  return (
    <span className="FirstMaiVisit">
      <span
        className="erg-margin-right-5 text-success"
        title={!showDesc ? title : ""}>
        <i className="fa fa-asterisk" />
      </span>
      {showDesc ? <span className="icon-desc">{title}</span> : null}
    </span>
  );
};

FirstMaiVisit.propTypes = {
  showDesc: PropTypes.bool,
  title: PropTypes.string,
};

FirstMaiVisit.defaultProps = {
  title: "First Maintenance Visit",
};

export default FirstMaiVisit;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/icons/FirstMaiVisit.js
 **/